<template>
  <div class="AddComment">
    <div v-if="!isReply" class="Title AddComment-Title">
      Добавить комментарий
    </div>
    <AddText
      :className="'AddComment-Edit'"
      v-model="commentTextData"
      ref="addText"
    />
    <div class="AddComment-Send">
      <BaseButton :onClickButton="sendComment">
        Отправить
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
const AddText = () =>
  import(/* webpackChunkName: "addText" */ "@/components/AddText.vue");
const BaseButton = () =>
  import(/* webpackChunkName: "baseButton" */ "@/components/BaseButton.vue");

export default {
  components: {
    AddText,
    BaseButton
  },

  props: {
    isReply: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapGetters(["article", "commentParent", "commentText"]),
    commentTextData: {
      get() {
        return this.commentText;
      },
      set(val) {
        this.updateCommentText(val);
      }
    }
  },

  methods: {
    ...mapMutations(["updateCommentText"]),
    ...mapActions(["sendComment"]),
    focus: function() {
      this.$el.scrollIntoView({ behaviour: "smooth" });
    }
  }
};
</script>

<style lang="scss">
.AddComment {
  margin-top: 15px;
  margin-bottom: 55px;

  &-Title {
    margin-bottom: 25px;
  }

  &-Edit {
    margin-bottom: 16px;
  }

  &-Send {
    text-align: right;
  }
}
</style>
